import type React from "react";

export function CheckBadgeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
      <circle cx="10" cy="10" r="8" fill="#3ECD58" />
      <path d="M8.6 12.35L6.7 10.45L5.95 11.2L8.6 13.85L14.05 8.4L13.3 7.65L8.6 12.35Z" fill="white" />
    </svg>
  );
}
